export const getGeographicalString = (geographical) => {
  const { resort, area, country } = geographical;
  const geographicalArray = [resort?.name, area?.name, country?.name].filter((g) => g); // Filter to remove null values
  const uniqueGeographicalArray = [...new Set(geographicalArray)]; // Remove duplicates
  return uniqueGeographicalArray.join(', ');
};
